import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { DividendEvent, GetDividendEventsResponse } from './types'

export const dividendEventsListMounted = createEvent()

export const getDividendEvents = fx<void, GetDividendEventsResponse>({
  method: 'GET',
  url: `/nova/dividend_event?order=paymentDate`,
})

export const $dividendEvents = restore<DividendEvent[]>(
  getDividendEvents.doneData.map((a) => a.body.dividendEvents),
  [],
)

sample({
  clock: dividendEventsListMounted,
  fn: () => ({}),
  target: getDividendEvents,
})
